import CourseItem from '../../../../../../components/Cards/CardComponents/CourseItem'
import { Course } from '../../../../../../types/course'

interface CourseSectionProps {
  courses: Course[]
}

export function CourseSection({ courses }: CourseSectionProps) {
  if (!courses?.length) return null

  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">Courses</h2>
      <div className="space-y-8">
        {courses.map((Course, index) => (
          <CourseItem key={index} course={Course} />
        ))}
      </div>
    </div>
  )
}
